// spinner-template.component.ts
import { Component } from '@angular/core';

@Component({
	selector: 'app-spinner-template',
	template: `
    <div class="h-100 w-100 d-flex align-items-center sfondo-loading">
      <div class="row">
        <i class="fa-solid fa-spinner fa-spin fa-3x text-kd-primary"></i>
      </div>
    </div>
  `,
	styles: [
		`
    .block-ui-template {
      background-color: #ffffff; /* Bianco */
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }
  `,
	],
})
export class SpinnerTemplateComponent {}
